module.exports = __webpack_public_path__ + "static/media/IMG_3375.9f4d2a47.JPG";